import { APP_ROUTES } from "@/core/constants";
import type { AppRouteDefinition } from "@/core/router";

import { TenantsPage } from "../views";
import TenantDetailsPage from "../views/details";

export const tenantsRoutes: readonly AppRouteDefinition[] = [
  {
    route: APP_ROUTES.superAdmin.tenants,
    element: <TenantsPage />,
    children: [
      {
        id: "superAdminTenantDetails",
        route: APP_ROUTES.superAdmin.tenants,
        element: <TenantDetailsPage />,
        path: `${APP_ROUTES.superAdmin.tenants.path}/:tenantId`,
      },
    ],
  },
] as const;
